<template>
  <div>
    <div style="display: flex; justify-content: center">
      <div class="card-box pl-4 pr-4">
        <div>
          <div
            class="mt-3 ml-3"
            v-if="content == '' && isLoading == false"
            style="color: grey"
          >
            Text example is here...
          </div>
          <div
            class="mt-3 ql-editor content-html"
            v-html="content"
            v-else
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { coreInstance, backendVersion } from "@/axios-path.js";
import "highlight.js/styles/tomorrow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  data() {
    return {
      content: "",
      isLoading: false,
    };
  },
  computed: {},
  methods: {},
  async created() {
    this.isLoading = true;
    await coreInstance
      .get(
        backendVersion.version + "/getInboxById/" + this.$route.params.blog_id
      )
      .then((res) => {
        this.content = res.data.data.notification_inbox_html;
      })
      .catch((err) => console.log(err));
    this.isLoading = false;
  },
};
</script>

<style scoped>
.card-box {
  height: 100vh;
  width: 1200px;
}
</style>

<style>
.content-html img {
  width: 100%;
  height: 100%;
}
</style>